import {cloneDeep as _cloneDeep} from 'lodash';
import SiteLogModel from "./../../models/SiteLogModel"
const SiteLogModule = {
    namespaced: true,
    state: () => ({
        siteLogsList: [],
        siteLogItem: _cloneDeep(SiteLogModel, true),
    }),
    getters: {
        getSiteLogsList (state) {
            return state.siteLogsList
        },
        getLogItem (state) {
            return state.siteLogItem
        },
    },
    mutations: {
        setSiteLogsList(state, payload) {
            state.siteLogsList = payload
        },
        setLogItem(state, payload) {
            state.siteLogItem = payload
        },
    },
    actions: {
        setSiteLogsList (context, payload) {
            context.commit('setSiteLogsList', payload);
        },
        setLogItem (context, payload) {
            context.commit('setLogItem', payload);
        },
    },
}

export default SiteLogModule;
